import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import moment from 'moment';
import useHandleErrors from '../../utils/user.utils';
import { useUser } from '../../utils/userContext';



const MedicalInsurances = () => {
    const [documents, setDocuments] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);
    const token = localStorage.getItem("token");
    const handleErrors = useHandleErrors();
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const hasFetchedRef = useRef(false);


    useEffect(() => {
        // if (!hasFetchedRef.current) {
            fetchDocuments(selectedYear);
            // hasFetchedRef.current = true;
        // }
    }, [selectedYear]);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const numberOfYearsToShow = 10; // Adjust this number as per your requirement
        if (years.length === 0) {
            const yearsToShow = Array.from({ length: numberOfYearsToShow }, (_, index) => currentYear - index);
            setYears(yearsToShow)
            // .reverse(); // Reverse to show from oldest to newest
        }
    }, [years]);


    const fetchDocuments = async (year) => {
        try {
            const path = `/documentReports?employeeId=${user?.EmployeeId}&documentType=Insurance&year=${year}`;
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const allDocuments = response.data;
            if (response.status == 200) {
                setDocuments(allDocuments.filter(doc => doc.DocumentURL.includes(year)));
            }
            else {
                handleErrors(response);
                setDocuments([])
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setDocuments([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };


    const downloadFile = (path) => {
        const link = document.createElement('a');
        link.href = path;
        link.setAttribute('download', 'document');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(documents);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Medical Insurance');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            link.download = 'Medical Insurance.xlsx';

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Medical Insurance List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(documents);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Assets');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'Medical Insurance.xlsx');
    };

    const shareData = {
        title: 'Medical Insurance List',
        text: 'Check out the Medical Insurance list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const ClearIndicator = () => null;

    return (
        <div>
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Medical Insurance</h3>
                        </div>
                        <div class="col-auto">
                            <Link to={'/policies'} class="btn btn-primary mt-lg-0 mt-4"><i class="ri-file-copy-2-line"></i>View Company Policies</Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-5 col-md-8 col-sm-10">
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                name="year"
                                                value={{ value: selectedYear, label: selectedYear }}
                                                onChange={(selectedOption) => setSelectedYear(selectedOption ? selectedOption.value : '')}
                                                options={years.map((year) => ({ value: year, label: year }))}
                                                isClearable
                                                components={{ ClearIndicator }}
                                                menuPortalTarget={document.body}
                                            />
                                            <small className="form-text text-muted text-center mt-0">
                                                <i className="ri-information-2-fill text-info"></i> Select Year
                                            </small>
                                        </div>
                                    </div>
                                    {/* <div className="row">
                                        <div className="col">
                                            <h5 className="title mt-1 mb-0">View Medical Insurance</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                                <i className="ri-mail-send-fill"></i>
                                            </button>
                                            <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                                <i className="ri-share-fill"></i>
                                            </button>
                                            <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                                <i className="ri-export-fill"></i>
                                            </button>
                                        </div>
                                    </div> */}
                                    <div className="row mt-3">
                                        <div className="col-md-12" id="employeeInsuranceList">
                                            {documents.length > 0 ? (
                                                <div>
                                                    <h6 className="title accordion-title" data-toggle="collapse" data-target={`#year${selectedYear}`}>
                                                        <i className="ri-calendar-2-line"></i> {selectedYear}
                                                        <span className="show-payslip-details float-right">
                                                            <div className="row">
                                                                <div className="col border-right"><i className="ri-file-copy-2-line"></i> Available Medical Insurance</div>
                                                                <div className="col-auto"><span className="text-success"> {documents.length}</span></div>
                                                            </div>
                                                        </span>
                                                    </h6>
                                                    <div className="collapse show" id={`#year${selectedYear}`} data-parent="#employeeInsuranceList">
                                                        <div className="row mt-3">
                                                            {documents.map((doc, index) => {
                                                                const pathParts = doc.DocumentURL.split('/');
                                                                const monthName = pathParts[pathParts.length - 4];
                                                                const fileName = pathParts[pathParts.length - 1].split('.')[0];
                                                                return (
                                                                    <div key={index} className="col-lg-3 col-md-6">
                                                                        <div className="card payslip-card mb-4">
                                                                            <div className="card-body">
                                                                                <div className="row align-items-center justify-content-between mb-2">
                                                                                    <div className="col-auto">
                                                                                        <div className="card ww-app-bg insurance-icon">
                                                                                            <div className="card-body p-1">
                                                                                                <span><i className="ri-file-list-3-line"></i></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <small className="col text-muted text-left px-0">{selectedYear}</small>
                                                                                    <div className="col-auto pl-0">
                                                                                        <button
                                                                                            className="btn btn-link text-info btn-action"
                                                                                            type="button"
                                                                                            title="Download"
                                                                                            onClick={() => downloadFile(doc.DocumentURL)}
                                                                                        >
                                                                                            <i className="ri-download-2-line"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                                <a href="#">
                                                                                    {/* <h5 className="title">{monthName}</h5> */}
                                                                                    <h5 className="title">{fileName}</h5>
                                                                                </a>
                                                                                <small className="text-muted">Uploaded On: {moment(doc.UploadedTime).format("DD-MM-YYYY")}</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="col">
                                                    <div class="no-data-found">
                                                        <i class="ri-calendar-fill"></i>
                                                        <div class="bounce ripple"><i class="ri-checkbox-circle-fill"></i></div>
                                                        <h6>No Medical Insurance found for the selected year</h6>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MedicalInsurances
